module.exports = " <div class=\"card float-e-margins\"> <div class=card-title> <h1>Kado service</h1> </div> <div class=\"card-content no-padding\"> <div class=row> <div class=col-md-12> <p> Wil je iets uit mijn kraam kado geven? <br> Dan kan ik het versturen naar het door jouw opgegeven adres en voorzien van een kadokaartje met een persoonlijke tekst. </p> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/customerService/giftService.vue
// module id = 652
// module chunks = 0